<template>
  <div id="FeatureHeadlines" class="mb-5 p-3">
    <div class="container">
      <b-row>
        <b-col
          sm
          v-for="feature in features"
          :key="feature.id"
          class="my-4"
          data-aos="fade-up"
        >
          <font-awesome-icon :icon="feature.icon" class="h1 text-dark" />
          <div class="h4 mt-3 text-primary">{{ feature.title }}</div>
          <div class="mt-3 text-secondary">{{ feature.description }}</div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          id: 1,
          title: "Works on all devices",
          description:
            "Designed to work on all devices including mobile, tablet and desktop.",
          icon: "mobile-alt"
        },
        {
          id: 2,
          title: "Fully Documented",
          description: "Easy to use documentation when you need a little help.",
          icon: "book"
        },
        {
          id: 3,
          title: "Easy Setup",
          description:
            "Fill in some details and your ready to go, we guide you through the progress.",
          icon: "check-circle"
        }
      ]
    };
  }
};
</script>

<style></style>
